/**
 * Initializes the page how-it-works module by dynamically importing the required module.
 * If the `.howItWorksPage` element is not found, the function exits early.
 *
 * @throws Will throw an error if the page how-it-works module fails to load.
 */
export const initializePageHowItWorksModule = async (): Promise<void> => {
  const pageElement = document.querySelector<HTMLElement>('.howItWorksPage');

  if (pageElement) {
    try {
      const { pageHowItWorks: pageHowItWorksModule } = await import(
        '../pages/page-how-it-works'
      );

      await pageHowItWorksModule();
    } catch (error: unknown) {
      // eslint-disable-next-line no-console
      console.error('🚨 Failed to load page-how-it-works module:', error);

      throw new Error(
        `Failed to load page-how-it-works module: ${
          error instanceof Error ? error.message : String(error)
        }`,
      );
    }
  }
};
